import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { CommandPalette } from './CommandPalette';
import { useUiStore } from '@/stores/ui.store';
import { useOrgTheme } from '@/hooks/useOrgTheme';
import { cn } from '@/lib/utils';
import { APP_NAME, COMPANY_NAME } from '@/lib/brand';

export function AppShell() {
  const sidebarOpen = useUiStore((s) => s.sidebarOpen);
  const location = useLocation();

  // Loads theme config and applies CSS vars via side-effect in the hook
  useOrgTheme();

  return (
    <div className="bg-background flex h-screen overflow-hidden">
      {/* Skip-nav: invisible until focused — lets keyboard users jump past the sidebar */}
      <a
        href="#main-content"
        className="focus:bg-background focus:text-foreground focus:ring-ring sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[200] focus:rounded-md focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:shadow-lg focus:ring-2"
      >
        Skip to main content
      </a>
      {/* Vayu orange bar across the top, as on vayusolar.com */}
      <div className="from-brand-orange via-brand-orange to-brand-amber bg-linear-to-r pointer-events-none fixed inset-x-0 top-0 z-50 h-[3px]" />
      <Sidebar />
      <div
        className={cn(
          'flex flex-1 flex-col overflow-hidden transition-all duration-300',
          'ml-0',
          sidebarOpen ? 'md:ml-64' : 'md:ml-16',
        )}
      >
        <Header />
        <main
          id="main-content"
          aria-label="Main content"
          className="flex-1 overflow-auto p-4 pb-20 md:p-6 md:pb-6"
        >
          <div key={location.pathname} className="animate-page-enter h-full">
            <Outlet />
          </div>
        </main>
        <footer className="bg-background mt-4 flex shrink-0 flex-col items-center gap-0.5 border-t px-6 py-2 md:flex-row md:justify-between">
          <span className="text-muted-foreground text-[11px]">
            © {new Date().getFullYear()} {COMPANY_NAME}
          </span>
          <span className="text-muted-foreground text-[11px]">{APP_NAME} · v1.0</span>
        </footer>
      </div>
      <BottomNav />
      <CommandPalette />
    </div>
  );
}
